/* Court Vibes, 17.09.2026. Setzt den Hinweis "Eigenes Vereinslogo hochladen"
   an die richtige Stelle der Produktseite.

   Warum ueberhaupt ein Skript, gemessen am 17.09.2026:
   Der Hinweis kommt aus einem custom-liquid Block in der Produktvorlage und
   steht dort zwischen Trennlinie und Kaufknopf-Block. teeinblue rendert aber
   SEINEN gesamten Bereich, also Preis, Farb- und Groessenauswahl UND das
   Personalisierungsformular, INNERHALB des Kaufknopf-Blocks. Gemessen: der
   Block buy-buttons-block war 1530 Pixel hoch. Der Hinweis landete dadurch
   ueber dem Preis statt ueber dem Uploadfeld. Aus der Vorlage heraus laesst
   sich das nicht loesen, weil man in den teeinblue-Bereich nichts einhaengen
   kann.

   Deshalb verschiebt dieses Skript den Hinweis direkt vor das Formular
   .tee-customize-main-form, dessen Kopfzeile "Personalisieren" heisst.

   Bis das geschehen ist, bleibt der Hinweis per CSS ausgeblendet, sonst blitzt
   er kurz an der falschen Stelle auf. Findet das Skript das teeinblue-Formular
   nicht, zum Beispiel weil die App langsam ist oder nicht laedt, zeigt es den
   Hinweis nach spaetestens zehn Sekunden trotzdem an, dann eben an der Stelle
   aus der Vorlage. Lieber am falschen Platz als gar nicht.

   Der Hinweis selbst steht in snippets/cv-logo-upload.liquid und erscheint nur
   bei Produkten mit dem Metafeld custom.logo_upload = true. */

(function () {
  var versuche = 0;
  var hoechstens = 40; // 40 mal 250 Millisekunden, also zehn Sekunden
  var fertig = false;

  function zeigen(schild) {
    schild.classList.add('cv-logo-upload--gesetzt');
  }

  function platzieren() {
    var schild = document.querySelector('.cv-logo-upload');
    if (!schild) return true; // Produkt ohne Metafeld, nichts zu tun

    var ziel = document.querySelector('.tee-customize-main-form');
    if (!ziel || !ziel.parentElement) return false;

    if (ziel.previousElementSibling !== schild) {
      ziel.parentElement.insertBefore(schild, ziel);
    }
    zeigen(schild);
    return true;
  }

  function starten() {
    if (fertig) return;
    if (platzieren()) {
      fertig = true;
      beobachten();
      return;
    }
    versuche = versuche + 1;
    if (versuche >= hoechstens) {
      var schild = document.querySelector('.cv-logo-upload');
      if (schild) zeigen(schild); // Notbremse, lieber sichtbar als verschwunden
      return;
    }
    window.setTimeout(starten, 250);
  }

  // teeinblue baut sein Formular bei einem Variantenwechsel neu auf. Dann steht
  // der Hinweis wieder woanders, deshalb nach jeder Aenderung erneut setzen.
  function beobachten() {
    var bereich = document.querySelector('.buy-buttons-block') || document.body;
    if (!window.MutationObserver) return;
    var wartet = false;
    var waechter = new MutationObserver(function () {
      if (wartet) return;
      wartet = true;
      window.setTimeout(function () {
        wartet = false;
        platzieren();
      }, 150);
    });
    waechter.observe(bereich, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', starten);
  } else {
    starten();
  }

  document.documentElement.style.setProperty('--cv-logoupload-js', 'on');
})();
